import {ISiteTextPreset, IWixStyleFont, wixFontParam} from '@wix/tpa-settings'
import {ReadOnlyExperiments} from '@wix/wix-experiments'

export interface GetDefaultValueProps {
  experiments: ReadOnlyExperiments
  colors: any[]
  dimensions: {height: number; width: number}
  getStyleParamValue: any
  isEditorX: boolean
  isMobile: boolean
  isRTL: boolean
  textPresets: any
}

export const getDefaultFont =
  (name: keyof ISiteTextPreset, options: Partial<IWixStyleFont> = {}) =>
  ({textPresets}: {textPresets: ISiteTextPreset}) => {
    if (options.style?.bold) {
      options.weight = 'bold'
    }

    const {value: _, ...font} = wixFontParam(name, options)({textPresets})

    return font as IWixStyleFont
  }
